<div class="card">
    <p-tabMenu [model]="items" [activeItem]="activeItem" (activeItemChange)="onActiveItemChange($event)" />
</div>

<div class="card">
    <bpc-chatbot
      [hidden]="activeItem?.label !== ExtensionTabs.TechAnalyst"
      [domain]="domain" />
  
    <bpc-prompt
      [hidden]="activeItem?.label !== ExtensionTabs.PromptManager"
      [isChatGPT]="chatGpt" />
  </div>